import React, { ReactNode } from 'react'
import MediaQuery from 'react-responsive'

import { ProductKey } from 'generated/types'
import Grid, { GridProps } from 'pages/invest/Grid'
import { ThinDivider } from 'pages/portfolio/styled-components'
import { routes } from 'router/routes'
import theme from 'theme'

import {
  ContentStatsContainer,
  GridContainer,
  ListContainer,
} from '../../styled-components'
import { StatYTDProps } from '../../types'
import { CryptoCard } from '../CryptoCard'
import { RebalanceNotification } from '../RebalanceNotification'

export type LayoutStatsBarProps = {
  totalStocksPercentage: string
  totalBondsPercentage: string
  totalCryptoPercentage?: string
} & StatYTDProps

type LayoutProps = {
  statsBar: ReactNode
  gridProps: GridProps
  eligibleForCrypto: boolean
  isPortfolioBeingRebalanced: boolean
  showGrid?: boolean
  product: ProductKey
}

const Layout = ({
  statsBar,
  gridProps,
  showGrid = true,
  eligibleForCrypto,
  isPortfolioBeingRebalanced,
  product,
}: LayoutProps) => (
  <>
    <MediaQuery minWidth={theme.breakpoints.sm + 1}>
      {statsBar}
      {eligibleForCrypto && (
        <CryptoCard linkTo={routes.portfolio.crypto.lander} />
      )}
      {product === ProductKey.Invest && isPortfolioBeingRebalanced && (
        <RebalanceNotification />
      )}
      {showGrid && (
        <>
          <ThinDivider />
          <GridContainer>
            <Grid {...gridProps} />
          </GridContainer>
        </>
      )}
    </MediaQuery>
    <MediaQuery maxWidth={theme.breakpoints.sm}>
      {product === ProductKey.Invest && isPortfolioBeingRebalanced && (
        <RebalanceNotification />
      )}
      <ListContainer showGrid={showGrid}>
        {showGrid && <Grid {...gridProps} />}
        {eligibleForCrypto && (
          <CryptoCard linkTo={routes.portfolio.crypto.lander} />
        )}
        <ContentStatsContainer>{statsBar}</ContentStatsContainer>
      </ListContainer>
    </MediaQuery>
  </>
)

export default Layout
